<template>
  <el-dialog :title="$i18n.t('wm_lang_cda4d5')" :visible.sync="innerVisible" :close-on-click-modal="false" width="720px">
    <div class="alertWinBox">
      <!--<RcptSelector :rcpts="rcpts" :orgTrees="orgTrees" :persTrees="persTrees" ref="rcptSelector"/>-->
      <div class="el-row">
        <div class="el-col el-col-11">
          <div class="left">
            <div class="el-input el-input--small el-input-group el-input-group--append">
              <label>
                <input type="text" v-bind:value="autocompleteFilterText" v-on:input="onChangeAutocompleteFilterText" autocomplete="off"
                       :placeholder="$i18n.t('wm_lang_d28df0')+'...'" class="el-input__inner">
              </label>
              <div class="el-input-group__append">
                <button @click="clearAutocomplete()" type="button" class="el-button el-button--default" style="padding: 12px;"><i
                    v-show="!enableAutocomplete" class="el-icon-search"/><i v-show="enableAutocomplete" class="el-icon-close"/></button>
              </div>
              <ul v-if="enableAutocomplete" class="ui-corner-all nice_scroll" style="max-height: 356px;">
                <li v-for="(item, index) in autocompleteItems" :key="index" :item="item" @click.prevent="toggleAutocompleteItem(item)">
                  <label class="el-checkbox" :class="{'is-checked': item.selected}">
                                            <span class="el-checkbox__input" :class="{'is-checked': item.selected}"><span
                                                class="el-checkbox__inner"/>
                                            <input type="checkbox" aria-hidden="false" class="el-checkbox__original" value=""></span>
                    <span class="el-checkbox__label">{{ item.first }}<b>{{ item.mid }}</b>{{ item.last }}</span>
                  </label>
                </li>
                <li v-if="autocompleteItems.length === 0"><span class="el-checkbox__label note-association">{{$t("wm_lang_html_ab9ed8")}}</span></li>
                <li v-if="autocompleteItems.length >= 200"><span
                    class="el-checkbox__label note-association">{{$t("wm_lang_html_5120e6")}}{{ autocompleteItems.length }}{{$t("wm_lang_html_413db9")}}</span>
                </li>
              </ul>
            </div>
            <div class="mt10">
              <el-tabs type="border-card">
                <el-tab-pane :label="$i18n.t('wm_lang_d43e13')">
                  <TreeView :root="orgTrees" :selector="selector" :clickCallback="handleNodeClick" class="nice_scroll"/>
                </el-tab-pane>
                <el-tab-pane :label="$i18n.t('wm_lang_d3298c')" v-if="persAddressPriv">
                  <TreeView :root="persTrees" :selector="selector" :clickCallback="handleNodeClick" class="nice_scroll"/>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
        <div class="el-col el-col-2">
          <div class="center">
            <a :title="$i18n.t('wm_lang_fb5bf1')" @click="addRcpts(selectedRcpts.tos)" class="el-link el-link--primary"> <span class="el-link--inner"><i
                class="el-icon-d-arrow-right"/></span></a>
            <a :title="$i18n.t('wm_lang_24969a')" @click="addRcpts(selectedRcpts.ccs)" class="el-link el-link--primary"><span class="el-link--inner"><i
                class="el-icon-d-arrow-right"/></span></a>
            <a :title="$i18n.t('wm_lang_76ea0d')" @click="addRcpts(selectedRcpts.bccs)" class="el-link el-link--primary"><span class="el-link--inner"><i
                class="el-icon-d-arrow-right"/></span></a>
          </div>
        </div>
        <div class="el-col el-col-11">
          <div class="right">
            <div role="tablist" aria-multiselectable="true" class="el-collapse">
              <div class="el-collapse-item is-active">
                <div role="tab" aria-expanded="true" aria-controls="el-collapse-content-8930" aria-describedby="el-collapse-content-8930">
                  <div role="button" id="el-collapse-head-8930" tabindex="0" class="el-collapse-item__header is-active">
                    {{$t("wm_lang_ac1e1c")}}<span id="maxNumDom" :class="selectedRcptsCount >= 1000 ? 'c_red' : ''">(<span id="maxNumTip"
                                                                                                         class="maxNumTip">{{
                      selectedRcptsCount
                    }}</span>/1000)</span>
                    <i class="header-icon el-icon-delete ml10" @click="clearRcpts()"/>
                    <!--<i class="el-collapse-item__arrow el-icon-arrow-right is-active"/>-->
                  </div>
                </div>
                <div role="tabpanel" aria-labelledby="el-collapse-head-8930" id="el-collapse-content-8930" class="el-collapse-item__wrap">
                  <div class="el-collapse-item__content">
                    <div>
                      <ul class="selected_to nice_scroll">
                        <li v-for="(rcpt,index) in selectedRcpts.tos" :key="index" @click="removeRcpts(selectedRcpts.tos, index)">
                          {{ rcpt.name }}&lt;{{ rcpt.email }}&gt;
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="el-collapse-item is-active">
                <div role="tab" aria-expanded="true" aria-controls="el-collapse-content-8826" aria-describedby="el-collapse-content-8826">
                  <div role="button" id="el-collapse-head-8826" tabindex="0" class="el-collapse-item__header is-active">
                    {{$t("wm_lang_24969a")}}<!--<i class="el-collapse-item__arrow el-icon-arrow-right is-active"/>-->
                  </div>
                </div>
                <div role="tabpanel" aria-labelledby="el-collapse-head-8826" id="el-collapse-content-8826" class="el-collapse-item__wrap">
                  <div class="el-collapse-item__content">
                    <div>
                      <ul class="selected_to nice_scroll">
                        <li v-for="(rcpt,index) in selectedRcpts.ccs" :key="index" @click="removeRcpts(selectedRcpts.ccs, index)">
                          {{ rcpt.name }}&lt;{{ rcpt.email }}&gt;
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="el-collapse-item is-active">
                <div role="tab" aria-expanded="true" aria-controls="el-collapse-content-5185" aria-describedby="el-collapse-content-5185">
                  <div role="button" id="el-collapse-head-5185" tabindex="0" class="el-collapse-item__header is-active">
                    {{$t("wm_lang_76ea0d")}}<!--<i class="el-collapse-item__arrow el-icon-arrow-right is-active"/>-->
                  </div>
                </div>
                <div role="tabpanel" aria-labelledby="el-collapse-head-5185" id="el-collapse-content-5185" class="el-collapse-item__wrap">
                  <div class="el-collapse-item__content">
                    <div>
                      <ul class="selected_to nice_scroll">
                        <li v-for="(rcpt,index) in selectedRcpts.bccs" :key="index" @click="removeRcpts(selectedRcpts.bccs, index)">
                          {{ rcpt.name }}&lt;{{ rcpt.email }}&gt;
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelDialog">{{$t("wm_lang_html_55c3f6")}} {{$t("wm_lang_html_aa4d94")}}</el-button>
      <el-button type="primary" @click="addContact">{{$t("wm_lang_html_2d7a2f")}} {{$t("wm_lang_html_a7a342")}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import _ from "lodash";
import TreeView from '../core/tree/TreeView.vue';
import OrgContacts from "../core/common/OrgContacts";
import BaseContactTree from "../core/common/BaseContactTree";
import BaseAutocomplete from "../views/member_selector/BaseAutocomplete";
import dialogHandle from "../../utils/dialogHandle";


export default {
    name: "selectContactDialog",
    mixins: [dialogHandle, BaseContactTree, BaseAutocomplete],
    components: {
        TreeView,
    },

    props: {
        getOrgTrees: {
            type: Function,
            default: null
        },
        getPersTrees: {
            type: Function,
            default: null
        },
        getMailContact: {
            type: Function,
            default: null
        },
        cancelSelectContact: {
            type: Function,
            default: null
        }
    },

    data: function () {
        return {
            rcpts: {
                tos: [],
                ccs: [],
                bccs: [],
            },
            //选择的收件人、抄送人、密送人
            selectedRcpts: {
                tos: [],
                ccs: [],
                bccs: [],
            },
        };
    },

    computed: {
        /**
         * 所有收件人数量
         * @returns {number}
         */
        selectedRcptsCount() {
            return this.selectedRcpts.tos.length + this.selectedRcpts.ccs.length + this.selectedRcpts.bccs.length;
        },
    },

    methods: {
        addContact() {
            if (this.getMailContact) {
                console.log(this.selectedRcpts)
                this.getMailContact(this.selectedRcpts);
            }
            this.cancelDialog()
        },

        cancelDialog() {
            if (this.cancelSelectContact) {
                this.cancelSelectContact();
            }
        },

        selectContactUpdate(recLabels, ccLabels, bccLabels) {
            let recTempArr = []
            recLabels.forEach((item) => {
                recTempArr.push({email: item.org, name: item.name})
            });
            this.selectedRcpts.tos = recTempArr;
            let ccTempArr = []
            ccLabels.forEach((item) => {
                ccTempArr.push({email: item.org, name: item.name})
            });
            this.selectedRcpts.ccs = ccTempArr;
            let bccTempArr = []
            bccLabels.forEach((item) => {
                bccTempArr.push({email: item.org, name: item.name})
            });
            this.selectedRcpts.bccs = bccTempArr;
        },

        /**
         * 添加收件人、抄送、密送
         * @param rcpts
         */
        addRcpts(rcpts) {
            let count = OrgContacts.Constant.MAX_RCPT_SELECTED_COUNT - this.selectedRcptsCount;
            let rcptSets = new Set();
            rcpts.forEach(rcpt => {
                rcptSets.add(rcpt.email)
            });
            if (count > 0) {
                this.autocompleteItems.forEach(function (value) {
                    if (!rcptSets.has(value.email) && value.selected && count-- > 0) {
                        rcpts.push(value);
                    }
                });
            }
            if (count > 0) {
                this.selector.selectIds.forEach(function (value) {
                    if (!rcptSets.has(value.email) && count-- > 0) {
                        rcpts.push(value);
                    }
                });
            }
            this.clearAutocomplete();
            this.clearSelected();
        },

        /**
         * 移除指定收件人、抄送、密送
         * @param rcpts
         * @param index
         */
        removeRcpts(rcpts, index) {
            if (rcpts && Array.isArray(rcpts) && rcpts.length > 0) {
                rcpts.splice(index, 1);
            }
        },

        /**
         * 清除所有收件人、抄送、密送
         */
        clearRcpts() {
            this.selectedRcpts.tos.splice(0, this.selectedRcpts.tos.length);
            this.selectedRcpts.ccs.splice(0, this.selectedRcpts.ccs.length);
            this.selectedRcpts.bccs.splice(0, this.selectedRcpts.bccs.length);
        },

        /**
         * 节点点击回调
         */
        handleNodeClick() {
            console.log(this.$i18n.t('wm_lang_b43f83'))
        },
    },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sub/selectContactDialog.vue